import { Box } from '@mui/material';
import React from 'react'

const SlideTransition = ({ targetNum, currentNum, children }) => {
    const ref = React.createRef();
    if (Math.abs(targetNum - currentNum) > 1) return null;
    // console.log('height', currentNum, ref.current);
    return (
        <Box
            ref={ref}
            sx={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                height: '100%',
                width: '100%',
                // px: { xs: '0.25rem', sm: '0.75rem' },
                left: targetNum === currentNum ? 0 : (targetNum > currentNum ? '100%' : '-100%'),
                transition: 'all 0.5s cubic-bezier(.39,.82,.35,.96)', width: '100%'
            }}>
            {children}
        </Box>
    )
}

export default SlideTransition